<template>
  <div class="myprops-root" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <div class="left-nav"></div>
          <!-- My Props -->
          <span class="tit-left">{{ $t('lang.MyProps.k001') }}</span>
        </template>
      </van-nav-bar>

      <div class="myprops-tab">
        <div :class="{ 'tab-on': tabIndex === 1 }" @click="handleTab(1)">{{ $t('lang.MyProps.k002') }}</div>
        <div :class="{ 'tab-on': tabIndex === 2 }" @click="handleTab(2)">{{ $t('lang.BaseModule.k016') }}</div>
        <div :class="{ 'tab-on': tabIndex === 3 }" @click="handleTab(3)">{{ $t('lang.MyProps.k003') }}</div>
      </div>
    </div>

    <!-- pass -->
    <div v-if="tabIndex === 1" class="myprops-content pass">
      <!-- banner -->
      <div class="banner-swipe">
        <swiper class="swiper-root" :options="swiperOptions">
          <swiper-slide v-for="item in serviceAdvantageData" :key="item.id">
            <div class="slide-item" @click="handleBannerClick(item)">
              <img :src="item.content | imgPath" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="prop-block">
        <div v-for="item in passList" class="prop-item" @click="handlePassUse(item)">
          <div class="item-top">
            <div v-if="item.remainTimeSeconds > 0" class="item-top-left">
              <!-- Permanent -->
              <template v-if="item.timeType === 'forever'">&nbsp;{{ $t('lang.BaseModule.k046') }}</template>
              <!-- xxd xxh -->
              <template v-if="item.timeType === 'days'">
                <div class="time-icon"></div>
                {{ transformSeconds2(item.remainTimeSeconds) }}
              </template>
              <!-- d:h:s -->
              <template v-if="item.timeType === 'hours'">
                <template v-if="item.countDown && item.countDown.countdownResult">
                  <div class="time-icon"></div>
                  {{ item.countDown.countdownResult.hours }}:{{ item.countDown.countdownResult.minutes }}:{{ item.countDown.countdownResult.seconds }}
                </template>
              </template>
            </div>
            <div v-else class="item-top-left"></div>
            <div class="detail-icon" @click.stop="handlePassTips(item)"></div>
          </div>
          <div class="pass-icon">
            <img v-if="item.propType == 15" :src="getMatchImg('super-chat-pass')" />
            <img v-if="item.propType == 1" :src="getMatchImg('super-chat-pass')" />
            <img v-if="item.propType == 2" :src="getMatchImg('video-pass')" />
            <img v-if="item.propType == 6" :src="getMatchImg('call-pass')" />
          </div>
          <div class="pass-name">{{ passTypeTxt[item.propType] }}</div>
          <div class="count">x{{ item.number }}</div>
          <div class="use">{{ $t('lang.BaseModule.k060') }}</div>
        </div>

        <no-data v-if="!passList.length"></no-data>
      </div>
    </div>

    <div v-if="tabIndex === 2" class="myprops-content coupon">
      <!-- prettier-ignore -->
      <div class="status-tab">
        <div :class="{ 'status-on': couponStatus === 0 }" @click="handleCouponStatus(0)">
          {{ $t('lang.BaseModule.k062') }}<template v-if="couponInfo">({{ couponInfo.validCount || 0 }})</template>
        </div>
        <div :class="{ 'status-on': couponStatus === 3 }" @click="handleCouponStatus(3)">
          {{ $t('lang.BaseModule.k022') }}<template v-if="couponInfo">({{ couponInfo.expireCount || 0 }})</template>
        </div>
        <div :class="{ 'status-on': couponStatus === 2 }" @click="handleCouponStatus(2)">
          {{ $t('lang.BaseModule.k061') }}<template v-if="couponInfo">({{ couponInfo.usedCount || 0 }})</template>
        </div>
      </div>

      <div v-for="(item, index) in couponList" :key="index" class="coupon-item" :class="{ 'coupon-off': couponStatus !== 0 }">
        <div class="coupon-con">
          <img v-if="couponStatus === 0" class="con-top-left" :src="getMatchImg('coin')" />
          <img v-else class="con-top-left" :src="getMatchImg('coin-off')" />
          <div class="con-top-center">
            <!-- prettier-ignore -->
            <div class="conpon-amount">
              {{ item.amount }} <i>{{ $t('lang.BaseModule.k071') }}</i>
            </div>
            <MyPLabel :str="item.descV2" :customClass="{ coin: 'coupon-coin-icon' }" class="conpon-tip"></MyPLabel>
          </div>
          <div v-if="couponStatus === 0" class="con-top-right" @click="handleCouponUse()">{{ $t('lang.BaseModule.k060') }}</div>
          <div v-if="couponStatus === 3" class="con-top-right">{{ $t('lang.BaseModule.k022') }}</div>
          <div v-if="couponStatus === 2" class="con-top-right">{{ $t('lang.BaseModule.k061') }}</div>
        </div>
        <div class="expires">
          {{ $t('lang.MyProps.k004') }}: {{ handleMoment(item.expiredTime, 'YYYY-MM-DD') }}
          <div class="circle1"></div>
          <div class="circle2"></div>
        </div>
      </div>

      <no-data v-if="!couponList.length"></no-data>
    </div>

    <div v-if="tabIndex === 3" class="myprops-content frame">
      <div v-for="item in frameList" :key="item.propId" class="prop-item">
        <div class="item-top">
          <div v-if="item.remainTimeSeconds > 0" class="item-top-left">
            <!-- Permanent -->
            <template v-if="item.timeType === 'forever'">&nbsp;{{ $t('lang.BaseModule.k046') }}</template>
            <!-- xxd xxh -->
            <template v-if="item.timeType === 'days'">
              <div class="time-icon"></div>
              {{ transformSeconds2(item.remainTimeSeconds) }}
            </template>
            <!-- d:h:s -->
            <template v-if="item.timeType === 'hours'">
              <template v-if="item.countDown && item.countDown.countdownResult">
                <div class="time-icon"></div>
                {{ item.countDown.countdownResult.hours }}:{{ item.countDown.countdownResult.minutes }}:{{ item.countDown.countdownResult.seconds }}
              </template>
            </template>
          </div>
          <div v-else></div>
          <div class="detail-icon" @click="handleFrameRules(item)"></div>
        </div>
        <div class="item-icon">
          <img :src="item.icon | imgPath" />
        </div>
        <!-- prettier-ignore -->
        <div v-if="item.status === 'beerExchange'" class="use btn1" @click="handleFrameItemClick(item)">
          {{ mybeers }}/{{ item.costPropNumber }}<img src="@/assets/packageAssets/common/beer.webp" />
        </div>
        <div v-if="item.ifValid && item.status === 'toTopUp'" class="use btn1" @click="handleFrameItemClick(item)">
          {{ $t('lang.MyProps.k023') }}
        </div>
        <div v-if="item.ifValid && item.status === 'jumpPath'" class="use btn1" @click="handleFrameItemClick(item)">
          {{ $t('lang.MyProps.k022') }}
        </div>
        <div v-if="item.ifValid && item.status === 'waitEquip'" class="use btn2" @click="handleFrameItemClick(item)">
          {{ $t('lang.MyProps.k005') }}
        </div>
        <div v-if="item.ifValid && item.status === 'beEquiped'" class="use btn2" @click="handleFrameItemClick(item)">
          {{ $t('lang.MyProps.k006') }}
        </div>
      </div>
      <no-data v-if="!frameList.length"></no-data>
    </div>

    <!-- pass rules -->
    <div v-if="passTypeShow" class="mask">
      <div class="pass-mask">
        <template v-if="passTypeShow === 2">
          <div class="pass-img">
            <img :src="getMatchImg('video-pass')" />
          </div>
          <div class="pass-txt">{{ passTypeTxt[passTypeShow] }}</div>
          <div class="pass-tips">
            1.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k007')"></MyPLabel>
          </div>
          <div class="pass-tips">
            2.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k008')" :numsOption="[{ value: baseInfo.videoPassServerTimeSeconds || '' }]"></MyPLabel>
          </div>
          <div class="pass-tips">
            3.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k009')"></MyPLabel>
          </div>
          <div class="pass-tips">
            4.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k010')"></MyPLabel>
          </div>
        </template>

        <template v-if="passTypeShow === 1 || passTypeShow === 15">
          <div class="pass-img">
            <img :src="getMatchImg('super-chat-pass')" />
          </div>
          <div class="pass-txt">{{ passTypeTxt[passTypeShow] }}</div>
          <div class="pass-tips">
            1.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k011')"></MyPLabel>
          </div>
          <div class="pass-tips">
            2.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k012')"></MyPLabel>
          </div>
          <div class="pass-tips">
            3.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k013')"></MyPLabel>
          </div>
        </template>

        <template v-if="passTypeShow === 6">
          <div class="pass-img">
            <img :src="getMatchImg('call-pass')" />
          </div>
          <div class="pass-txt">{{ passTypeTxt[passTypeShow] }}</div>
          <div class="pass-tips">
            1.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k014')"></MyPLabel>
          </div>
          <div class="pass-tips">
            2.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k015')"></MyPLabel>
          </div>
          <div class="pass-tips">
            3.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k016')"></MyPLabel>
          </div>
          <div class="pass-tips">
            4.&nbsp;
            <MyPLabel :str="$t('lang.MyProps.k017')"></MyPLabel>
          </div>
        </template>

        <div class="pass-mask-btn" @click="passTypeShow = ''">{{ $t('lang.BaseModule.k073') }}</div>
      </div>
      <div :style="{ height: `${bottomBarHeight}px` }"></div>
    </div>

    <!-- frame rules -->
    <div v-if="frameTypeShow" class="mask">
      <div class="pass-mask">
        <div class="pass-img">
          <img :src="frameTypeShow.icon | imgPath" />
        </div>
        <template v-for="(item, index) in frameTypeTxtArr">
          <div v-if="index === 0" class="pass-txt">{{ item }}</div>
          <div v-else class="pass-tips">{{ item }}</div>
        </template>

        <div class="pass-mask-btn" @click="frameTypeShow = null">{{ $t('lang.BaseModule.k073') }}</div>
      </div>
      <div :style="{ height: `${bottomBarHeight}px` }"></div>
    </div>
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/MyProps/z-style-cfg.js'
import {
  getBaseInfo,
  getBanner,
  getUserProps,
  getPropInfo,
  getCouponInfo,
  getCouponList,
  getUserFrames,
  equipFrame,
  unequipFrame,
  exchangeFrame,
} from '@/api/imee.js'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import CountDownClass from '@/utils/count-down.js'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  mixins: [pageCssVars],
  data() {
    const chatPassLang = this.$t('lang.MyProps.k024')
    const callPassLang = this.$t('lang.MyProps.k020')
    const matchPassLang = this.$t('lang.MyProps.k021')
    return {
      tabIndex: 0,
      couponStatus: 0,

      baseInfo: null,

      // banner
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
        slidesPerView: 1,
        centeredSlides: true,
        paginationClickable: true,
        autoplay: false,
      },
      serviceAdvantageData: [],

      // pass
      passList: [],
      passTypeShow: null,
      passTypeTxt: {
        15: chatPassLang,
        1: chatPassLang,
        2: matchPassLang,
        6: callPassLang,
      },

      // coupon
      couponInfo: null,
      couponList: [],

      // frame
      frameList: [],
      frameTypeShow: null,
      frameTypeTxtArr: [],
      mybeers: 0,
    }
  },
  methods: {
    handleTab(arg) {
      this.tabIndex = arg
      if (arg === 1) {
        this.initPass()
        return
      }
      if (arg === 2) {
        this.initCoupon()
        return
      }
      if (arg === 3) {
        this.initFrame()
      }
    },
    // pass
    initPass() {
      getBanner().then((res) => {
        if (res && !res.error) {
          this.serviceAdvantageData = res
        }
      })
      getUserProps().then((res) => {
        if (res && !res.error) {
          if (res.length) {
            res.forEach((item) => {
              if (item.remainTimeSeconds > 0 && item.remainTimeSeconds <= 86400) {
                item.timeType = 'hours'
                item.countDown = new CountDownClass()
                item.countDown.initCountDown(item.remainTimeSeconds, 'HMS')
                return
              }
              if (item.remainTimeSeconds > 86400 && item.remainTimeSeconds <= 2592000) {
                item.timeType = 'days'
                return
              }
              if (item.remainTimeSeconds > 2592000) {
                item.timeType = 'forever'
              }
            })
            this.passList = res.sort((a, b) => a.remainTimeSeconds - b.remainTimeSeconds)
          }
        }
      })
    },
    handlePassTips(item) {
      this.passTypeShow = item.propType
    },
    handlePassUse(item) {
      // Match Pass
      if (item.propType === 2) {
        this.appAction('open_match_page')
        return
      }
      // Call Pass
      if (item.propType === 6) {
        this.appAction('open_call_pass_recommend')
        return
      }
      // Chat Pass
      if (item.propType === 1 || item.propType === 5 || item.propType === 15) {
        this.appAction('open_session_page')
      }
    },
    handleBannerClick(item) {
      item.goUrl && this.appActionPro(item.goUrl)
    },
    // coupon
    initCoupon() {
      getCouponInfo().then((res) => {
        if (res && !res.error) {
          this.couponInfo = res || null
        }
      })
      this.handleCouponStatus(0)
    },
    handleCouponStatus(arg) {
      this.couponList = []
      this.couponStatus = arg
      getCouponList({ state: arg }).then((res) => {
        if (res && !res.error) {
          this.couponList = res || []
        }
      })
    },
    handleCouponUse() {
      this.appAction('open_store_page')
    },
    // frame
    initFrame() {
      getPropInfo(7).then((res) => {
        if (res && !res.error) {
          this.mybeers = res.totalNumber
        }
      })
      getUserFrames().then((res) => {
        if (res && !res.error) {
          if (res.length) {
            res.forEach((item) => {
              // 非数值 - 需要兑换或充值
              if (typeof item.state !== 'number') {
                // 啤酒兑换
                if (item.costPropType === 7) {
                  item.status = 'beerExchange'
                }
                //
                else {
                  if (item.modelId == 0 || item.modelId == 1) {
                    item.status = 'toTopUp'
                  }
                  //
                  else {
                    item.status = 'jumpPath'
                  }
                }
              }
              // 是数值 - 以获取的
              else {
                if (item.state === 0) {
                  item.status = 'waitEquip'
                }
                if (item.state === 1) {
                  item.status = 'beEquiped'
                }
              }

              if (typeof item.expiredTimeSeconds === 'number') {
                item.remainTimeSeconds = item.expiredTimeSeconds
                if (item.remainTimeSeconds > 0 && item.remainTimeSeconds <= 86400) {
                  item.timeType = 'hours'
                  item.countDown = new CountDownClass()
                  item.countDown.initCountDown(item.remainTimeSeconds, 'HMS')
                  return
                }
                if (item.remainTimeSeconds > 86400 && item.remainTimeSeconds < 2592000) {
                  item.timeType = 'days'
                  return
                }
                if (item.remainTimeSeconds >= 2592000) {
                  item.timeType = 'forever'
                }
              }
            })
            this.frameList = res.sort((a, b) => a.sort - b.sort)
          }
        }
      })
    },
    handleFrameRules(item) {
      this.frameTypeShow = item
      if (item.tip) {
        this.frameTypeTxtArr = item.tip.split('\n')
      }
    },
    handleFrameItemClick(item) {
      if (item && item.status === 'beerExchange') {
        if (this.mybeers < item.costPropNumber) {
          this.$client.showToast(this.$t('lang.MyProps.k018'))
          return
        }
        exchangeFrame(10, item.propId).then((res) => {
          if (res && !res.error) {
            this.$client.showToast(this.$t('lang.MyProps.k019'))
            this.handleTab(3)
          }
        })
        return
      }
      if (item && item.status === 'toTopUp') {
        item.goUrl && this.appActionPro(item.goUrl)
        return
      }
      if (item && item.status === 'jumpPath') {
        item.goUrl && this.appActionPro(item.goUrl)
        return
      }
      if (item && item.status === 'waitEquip') {
        equipFrame(10, item.propId).then((res) => {
          if (res && !res.error) {
            this.handleTab(3)
          }
        })
        return
      }
      if (item && item.status === 'beEquiped') {
        unequipFrame(10, item.propId).then((res) => {
          if (res && !res.error) {
            this.handleTab(3)
          }
        })
      }
    },
    init() {
      getBaseInfo().then((res) => {
        if (res && !res.error) {
          this.baseInfo = res
        }
      })
      this.handleTab(1)
    },
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss">
.myprops-root {
  width: 100vw;
  min-height: 100vh;
  background-color: var(--page-color01, #f0f1f2);

  .custom-nav-block {
    background: var(--page-color02, #f9fafa);

    .left-nav {
      width: 24px;
      height: 24px;
      background: var(--back-arrow) left top / 100% auto no-repeat;
    }

    .myprops-tab {
      width: 100%;
      background: var(--page-color02, #f9fafa);
      border-bottom: 1px solid var(--page-color03, #e3e4e5);
      display: flex;
      height: 44px;
      justify-content: center;
      align-items: center;
      align-self: stretch;

      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-24);
      font-style: normal;
      color: var(--page-color04, #5f656a);

      > div {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .tab-on {
        font-weight: var(--fw-700);
        color: var(--page-color05, #202326);
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;

          width: 100%;
          height: 2px;
          border-radius: 4px 4px 0 0;
          background: var(--page-color06, #0c0e11);
        }
      }
    }
  }

  .myprops-content {
    width: 100%;
    padding: 12px;
  }

  .pass {
    padding: 12px 0;
    .prop-block {
      padding: 0 12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .prop-item {
        width: 170px;
        height: 212px;
        margin-bottom: 12px;
        border-radius: 8px;
        background: var(--page-color07, #f9fafa);
        overflow: hidden;
        position: relative;

        .item-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-top-left {
            height: 24px;
            padding: 0 8px 0 4px;
            border-radius: 0 0 8px 0;
            background: var(--page-color08, #e3e4e5);
            display: flex;
            align-items: center;
            justify-content: center;

            font-family: var(--string-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-400);
            line-height: var(--lh-title-24);
            font-style: normal;
            color: var(--page-color09, #353a3f);
            .time-icon {
              width: 16px;
              height: 16px;
              background: var(--icon-time) left top / 100% auto no-repeat;
            }
          }
          .detail-icon {
            box-sizing: content-box;
            width: 16px;
            height: 16px;
            border: 4px solid transparent;
            background: var(--icon-details) left top / 100% auto no-repeat;
          }
        }
        .pass-icon {
          width: 96px;
          height: 96px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 85%;
          }
        }
        .pass-name {
          width: 100%;
          text-align: center;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-500);
          line-height: var(--lh-title-20);
          font-style: normal;
          color: var(--page-color09, #353a3f);
        }
        .count {
          width: 100%;
          text-align: center;
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-500);
          line-height: var(--lh-body-20);
          font-style: normal;
          color: var(--page-color10, #202326);
        }
        .use {
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--page-color11, #ffa433);
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-500);
          line-height: var(--lh-title-24);
          font-style: normal;
          color: var(--page-color12, #733406);
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          padding: 7px 16px;
        }
      }
    }
  }

  .coupon {
    .status-tab {
      width: 343px;
      height: 40px;
      margin: 0 auto 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: var(--page-radius1, 30px);
      background: var(--page-color13, #e3e4e5);
      > div {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        display: flex;
        padding: 6px 16px;
        justify-content: center;
        align-items: center;
        border-radius: var(--page-radius2, 33px);
        text-align: center;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        font-weight: var(--fw-400);
        line-height: var(--lh-title-20);
        color: var(--page-color14, #5f656a);
      }
      .status-on {
        background: var(--page-color15, #fafafa);
      }
    }

    .coupon-item {
      width: 343px;
      margin-bottom: 10px;
      border-radius: var(--page-radius3, 8px);
      background-color: var(--page-color16, #f9fafa);

      .coupon-con {
        padding: 8px 16px;
        display: flex;
        align-items: center;
        .con-top-left {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
        .con-top-center {
          flex: 1;
          padding: 0 6px;
          .conpon-amount {
            font-family: var(--string-font);
            font-size: var(--fs-24);
            font-weight: var(--fw-700);
            line-height: var(--lh-headline-32);
            color: var(--page-color17, #ffa433);

            i {
              font-family: var(--string-font);
              font-size: var(--fs-20);
              font-weight: var(--fw-400);
              line-height: var(--lh-title-28);
            }
          }
          .conpon-tip {
            font-family: var(--string-font);
            font-size: var(--fs-12);
            font-weight: var(--fw-400);
            line-height: var(--lh-label-18);
            color: var(--page-color18, #202326);

            .coupon-coin-icon {
              width: 16px;
              height: 16px;
              vertical-align: middle;
            }
          }
        }
        .con-top-right {
          min-width: 80px;
          min-height: 32px;
          padding: 0 4px;
          border-radius: var(--page-radius4, 16px);
          background-color: var(--page-color19, #ffa433);
          display: flex;
          justify-content: center;
          align-items: center;

          font-family: var(--string-font);
          font-size: var(--fs-12);
          font-weight: var(--fw-700);
          line-height: var(--lh-label-18);
          color: var(--page-color20, #733406);
        }
      }
      .expires {
        display: flex;
        width: 343px;
        padding: 8px 10px;
        justify-content: center;
        align-items: center;
        border-top: 2px dashed var(--page-color21, #f0f1f2);
        font-family: var(--string-font);
        font-size: var(--fs-10);
        font-weight: var(--fw-400);
        line-height: var(--lh-label-14);
        font-style: normal;
        color: var(--page-color22, #8e9092);
        position: relative;
        .circle1,
        .circle2 {
          width: 12px;
          height: 12px;
          border-radius: 12px;
          background-color: var(--page-color23, #f0f1f2);
          position: absolute;
          top: -6px;
        }
        .circle1 {
          left: -6px;
        }
        .circle2 {
          right: -6px;
        }
      }
    }

    .coupon-off {
      .coupon-con {
        .con-top-center {
          .conpon-amount {
            color: var(--page-color24, #5f656a);
          }
          .conpon-tip {
            .coupon-coin-icon {
              filter: grayscale(1);
            }
          }
        }
        .con-top-right {
          background-color: var(--page-color25, #e3e4e5);
          color: var(--page-color26, #a4a5a8);
        }
      }
    }
  }

  .frame {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .prop-item {
      width: 170px;
      height: 178px;
      margin-bottom: 12px;
      border-radius: 8px;
      background: var(--page-color27, #f9fafa);
      overflow: hidden;
      position: relative;

      .item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item-top-left {
          height: 24px;
          padding: 0 8px 0 4px;
          border-radius: 0 0 8px 0;
          background: var(--page-color28, #e3e4e5);
          display: flex;
          align-items: center;
          justify-content: center;

          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          line-height: var(--lh-title-24);
          font-style: normal;
          color: var(--page-color29, #353a3f);
          .time-icon {
            width: 16px;
            height: 16px;
            background: var(--icon-time) left top / 100% auto no-repeat;
          }
        }
        .detail-icon {
          box-sizing: content-box;
          width: 16px;
          height: 16px;
          border: 4px solid transparent;
          background: var(--icon-details) left top / 100% auto no-repeat;
        }
      }
      .item-icon {
        width: 96px;
        height: 96px;
        margin: 8px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 85%;
        }
      }
      .count {
        width: 100%;
        text-align: center;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-500);
        line-height: var(--lh-body-20);
        font-style: normal;
        color: var(--page-color30, #202326);
      }
      .use {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-500);
        line-height: var(--lh-title-24);
        font-style: normal;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 7px 16px;

        img {
          width: 20px;
          height: 20px;
          margin: 0 4px;
        }
      }
      .btn1 {
        background: var(--page-color31, #ffa433);
        color: var(--page-color32, #733406);
      }
      .btn2 {
        background: var(--page-color33, #fff4d6);
        color: var(--page-color34, #ffa433);
      }
    }
  }

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background: var(--page-color35, rgba(0, 0, 0, 0.6));
    padding-bottom: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .pass-mask {
    width: 343px;
    padding: 20px 16px;
    border-radius: 12px;
    background: var(--page-color36, #fafafa);

    .pass-img {
      width: 96px;
      height: 96px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 100%;
      }
    }
    .pass-txt {
      width: 100%;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-500);
      line-height: var(--lh-title-24);
      font-style: normal;
      color: var(--page-color37, #202326);
      margin-bottom: 16px;
    }
    .pass-tips {
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      font-style: normal;
      color: var(--page-color38, #5f656a);
      display: flex;
      margin-bottom: 4px;
    }
    .pass-mask-btn {
      width: 311px;
      height: 48px;
      margin: 16px auto;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: var(--page-radius5, 48px);
      background: var(--page-color39, #0c0e11);
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-500);
      line-height: var(--lh-title-24);
      font-style: normal;
      color: var(--page-color40, #fafafa);
    }
  }

  .banner-swipe {
    width: 100%;
    margin-bottom: 12px;
    .swiper-root {
      width: 100%;
      .swiper-slide {
        width: 100%;
        .slide-item {
          width: 100%;
          height: auto;
          padding: 0 12px;
          position: relative;
          border-radius: 10px;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }

  .van-nav-bar__left .tit-left {
    padding: 0 16px;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .myprops-root .frame .prop-item .item-top .item-top-left {
    border-radius: 8px 0 0 8px;
  }
}
</style>
